import { api } from '@/core/helpers/axiosHelper';

export default {
   async get(search?: string, filter_employer_tenant_id?: number) {
      return await api
         .get('/company', {
            params: {
               'filter[search]': search,
               'filter[employer_tenant_id]': filter_employer_tenant_id,
               per_page: 40,
            },
         })
         .then((response) => response.data);
   },
};
